
<div id="hero-banner" class="hero-banner">
  @if (city && (!tags || tags.length === 0)) {
    @if (city === 'paris') {
      <div class="hero-banner__background">
        <img src="assets/images/cities/france-paris.jpg" alt="Paris" />
      </div>
    }
    @if (city === 'marseille') {
      <div class="hero-banner__background">
        <img src="assets/images/cities/france-marseille.jpg" alt="Marseille" />
      </div>
    }
    @if (city === 'lyon') {
      <div class="hero-banner__background">
        <img src="assets/images/cities/france-lyon.jpg" alt="Lyon" />
      </div>
    }
    @if (city === 'bordeaux') {
      <div class="hero-banner__background">
        <img src="assets/images/cities/france-bordeaux.jpg" alt="Bordeaux" />
      </div>
    }
    @if (city === 'toulouse') {
      <div class="hero-banner__background">
        <img src="assets/images/cities/france-toulouse.jpg" alt="Toulouse" />
      </div>
    }
    @if (city === 'lille') {
      <div class="hero-banner__background">
        <img src="assets/images/cities/france-lille.jpg" alt="Lille" />
      </div>
    }
  }

  <div class="hero-banner__overlay">

    @if (city && (!tags || tags.length === 0)) {
      <h1 class="hero-banner__title">{{'marketplace.search.title.city'|transloco:{'city': city|titlecase} }}</h1>
    } @else if (!city && tags && tags.length > 0) {
      <h1 class="hero-banner__title">{{'marketplace.search.title.tag'|transloco:{'tag': ('marketplace.photographer.tags.' + tags[0])|transloco} }}</h1>
    } @else if (city && tags && tags.length > 0) {
      <h1 class="hero-banner__title">{{'marketplace.search.title.city-tag'|transloco:{'city': city|titlecase, 'tag': ('marketplace.photographer.tags.' + tags[0])|transloco} }}</h1>
    }

    <div class="hero-banner__overlay-content">
      <app-search-banner
        [city]="city"
        [tags]="tags"
        (onCityChange)="cityChanged($event)"
        (onTagsChange)="tagsChanged($event)"
      ></app-search-banner>
    </div>
  </div>
</div>
